import { render, staticRenderFns } from "./StandaloneWp.vue?vue&type=template&id=1d7bafb2&scoped=true&"
import script from "./StandaloneWp.vue?vue&type=script&lang=js&"
export * from "./StandaloneWp.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneWp.vue?vue&type=style&index=0&id=1d7bafb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bafb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7bafb2')) {
      api.createRecord('1d7bafb2', component.options)
    } else {
      api.reload('1d7bafb2', component.options)
    }
    module.hot.accept("./StandaloneWp.vue?vue&type=template&id=1d7bafb2&scoped=true&", function () {
      api.rerender('1d7bafb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/StandaloneWp.vue"
export default component.exports